import {EVENT_ID} from './constants';

const sendEvent = payload => {
  const event = new CustomEvent(EVENT_ID, {
    detail: {
      ...payload
    }
  });
  document.dispatchEvent(event);
};

export default sendEvent;
